module.exports = __webpack_public_path__ + "static/media/20180524-LCS-022-15.68bf27a9.jpg";